var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#3057B9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.183.312c.416-.416 1.09-.416 1.505 0 .38.38.416.983.074 1.422l-.074.083L10.505 9l7.183 7.183c.39.39.414 1.006.073 1.424l-.073.081c-.38.38-.983.416-1.422.074l-.083-.074L9 10.505l-7.183 7.183c-.39.39-1.006.414-1.424.073l-.081-.073c-.38-.38-.416-.983-.074-1.422l.074-.083L7.495 9 .312 1.817C-.078 1.427-.102.81.239.393L.312.312c.38-.38.983-.416 1.405-.088l.1.088L9 7.495z",
    transform: "translate(-845.000000, -91.000000) translate(141.000000, 71.000000) translate(704.000000, 20.000000)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseX);
export default __webpack_public_path__ + "static/media/closeX.4803b1ea88024fd51cefe4d8904981f2.svg";
export { ForwardRef as ReactComponent };